import React from "react";
import { Box, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useMassFormatter } from "hooks/useMassFormatter";

interface BasketHeaderProps {
  basketNumber: number;
  totalMass: number;
  fullness: number;
}

export const BasketsTabBasketHeader: React.FC<BasketHeaderProps> = ({
  basketNumber,
  totalMass,
  fullness,
}) => {
  const { t } = useTenantTranslation();
  const { formatMass } = useMassFormatter();

  return (
    <Box sx={{ textAlign: "center", mb: 1 }}>
      <Typography variant="h6" sx={{ fontWeight: "fontWeightBold" }}>
        {t("basketCapitalised")} {basketNumber}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {formatMass(totalMass)}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {(fullness * 100).toFixed(0)}% {t("full")}
      </Typography>
    </Box>
  );
};
